let apiSubdomain = `https://api.`;
if(process.env.NODE_ENV === 'development')
  apiSubdomain = `https://stage-api.`;

export const COGNITO_USER_POOL_CLIENT_ID = "2fs2geiekfaonh5thfhsfvstdm";

export const DIGMS_API_BASE_URL = process.env.REACT_APP_DIGMS_API_BASE_URL; // Set in Jenkinsfile or .env
export const DS_BASE_URL = apiSubdomain + DIGMS_API_BASE_URL; 

// export const DS_BASE_URL = "http://webapi.115.dev.dealerspike.net" //DEV SERVER

export const ACCURANKER_KEYWORD_ENDPOINT = "/accuranker/keywords"
export const RDS_KEYWORD_PUSH_ENDPOINT = "/public-rds/keywords/push"
export const CLIENTS_ENDPOINT = '/clients';
export const GET_ALL_PACKAGES_ENDPOINT = "/clients/packages";
export const GET_ALL_VERTICALS_ENDPOINT = "/clients/verticals";
export const BULK_UPLOAD_API_DS_ENDPOINT = "/seo-bulk-update/snippets/ds";

export const CONTENT_GENERATION_API_DS_ENDPOINT = "/general-digms-rds/seo-content";
export const DEALER_VARS_ENDPOINT = "/general-digms-rds/seo-content/dealer-vars";
export const EXPORT_CSV_ENDPOINT = "/general-digms-rds/seo-content/zip/csv";

export const LLM_SUBMIT_ENDPOINT = "/llm/submit";
export const LLM_STATUS_ENDPOINT = "/llm/status";
export const LLM_RESULT_ENDPOINT = "/llm/result";

// Authentication
export const APP_BASE_URL = process.env.REACT_APP_BASE_URL // Set in Jenkinsfile
export const APP_BASE_URL_DEV = "http://localhost:3000" // DEV URL
